import WidgetModule from "@eisinc/Overrides/Widgets/SavedPayments/SavedPaymentsAddCardButton";

export * from "@eisinc/Overrides/Widgets/SavedPayments/SavedPaymentsAddCardButton";

export default WidgetModule;
